'use client';

import { useEffect, useCallback } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { TOUR_STEPS, TOUR_STORAGE_KEY, TourRole } from '@/lib/tour-steps';

async function getDriver() {
  const { driver } = await import('driver.js');
  return driver;
}

export default function AppTour() {
  const { role, user } = useAuth();

  const startTour = useCallback(async () => {
    const driverFn = await getDriver();

    const userRole = (role || 'free') as TourRole;
    const filteredSteps = TOUR_STEPS.filter(step => {
      const el = document.querySelector(step.element);
      if (!el) return false;
      if (step.roles && !step.roles.includes(userRole)) return false;
      return true;
    });

    if (filteredSteps.length === 0) return;

    const driverObj = driverFn({
      animate: true,
      smoothScroll: true,
      allowClose: true,
      overlayOpacity: 0.75,
      stagePadding: 8,
      stageRadius: 12,
      popoverClass: 'askforos-tour-popover',
      nextBtnText: 'Επόμενο →',
      prevBtnText: '← Πίσω',
      doneBtnText: 'Τέλος ✓',
      progressText: ' από ',
      showProgress: true,
      onDestroyed: () => {
        localStorage.setItem(TOUR_STORAGE_KEY, 'done');
      },
      steps: filteredSteps.map(step => ({
        element: step.element,
        popover: {
          title: step.popover.title,
          description: step.popover.description,
          side: step.popover.side || 'right',
          align: step.popover.align || 'start',
        },
      })),
    });

    driverObj.drive();
  }, [role]);

  // Auto-start on first login
  useEffect(() => {
    if (!user) return;
    const alreadySeen = localStorage.getItem(TOUR_STORAGE_KEY);
    if (alreadySeen) return;
    const timer = setTimeout(() => startTour(), 1800);
    return () => clearTimeout(timer);
  }, [user, startTour]);

  // Expose to window for replay button
  useEffect(() => {
    (window as any).__askforosTour = startTour;
    return () => { delete (window as any).__askforosTour; };
  }, [startTour]);

  return null;
}
